// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import PFrownOutlinedSvg from "@fishx/icons-svg/es/asn/PFrownOutlined";
import FishxIcon from '../components/FishxIcon';

var PFrownOutlined = function PFrownOutlined(props, ref) {
  return React.createElement(FishxIcon, Object.assign({}, props, {
    ref: ref,
    icon: PFrownOutlinedSvg
  }));
};

PFrownOutlined.displayName = 'PFrownOutlined';
export default React.forwardRef(PFrownOutlined);


//////////////////
// WEBPACK FOOTER
// ./node_modules/@fishx/icons/es/icons/PFrownOutlined.js
// module id = 3427
// module chunks = 0